export default __webpack_public_path__ + "static/media/WAULTx.f599775f.svg";